import createRoute from '@widesk-ui/tools/createRoute';
import UserModel   from '@models/website/UserModel';

const route = createRoute.splitView(
	'/configuration/users',
	'website',
	'UserSplitView',
	UserModel.localize('plural'),
);
export default route;
